import React, { useState } from "react";
import SortArrowIcon from "assets/icons/small-up-arrow.svg";
import classNames from "classnames";
import { Sort } from "constants/enums";
import PropTypes from "prop-types";

const SortHeader = ({ title, field, value, onChange, disabled = false }) => {
  const sortName = !!value ? value.sortName : null;
  const sortDirection = !!value ? value.sortDirection : null;

  const isAsc = sortName == field && sortDirection == Sort.Asc;
  const isDesc = sortName == field && sortDirection == Sort.Desc;

  return (
    <div
      className={classNames("sort-header", disabled ? "disabled" : "")}
      onClick={() => {
        if (disabled) {
          return;
        }
        let next = null;
        if (sortName != field) {
          next = Sort.Asc;
        } else {
          switch (sortDirection) {
            case Sort.Asc:
              next = Sort.Desc;
              break;
            case null:
              next = Sort.Asc;
              break;
            default:
              next = null;
              break;
          }
        }
        onChange({
          ...value,
          sortName: next != null ? field : null, // remove sort name if no direction
          sortDirection: next,
        });
      }}
    >
      <div className="sort-content">{title}</div>
      <div
        className={classNames(
          "sort-arrows",
          isAsc ? "asc" : null,
          isDesc ? "desc" : null,
          disabled ? "hidden" : null
        )}
      >
        <img className="asc-arrow" src={SortArrowIcon} />
        <img className="desc-arrow" src={SortArrowIcon} />
      </div>
    </div>
  );
};

SortHeader.propTypes = {
  title: PropTypes.any,
  field: PropTypes.string,
  value: PropTypes.shape({
    sortName: PropTypes.string,
    sortDirection: PropTypes.string,
  }),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default SortHeader;
